import { mapState } from 'vuex';
import footerComponent from '../footerComponent/index.vue'
export default {
    name: 'registration',
    props: {
        type : Number
    },

    components : {
        footerComponent
    },

    data : function(){

        return {
            loading : false,
            values : {},


            fields : [
                {
                    id : 'Email',
                    text : 'fields.Email',
                    textrequired : 'fields.emailRequiered',
                    rules : [{
                        rule : 'required'
                    },{
                        rule : 'email'
                    },{
                        rule : 'min:5'
                    }]
                },
                {
                    id : 'Password',
                    text : 'fields.password',
                    textrequired : 'fields.passwordRequiered',
                    type : "password",
                    rules : [{
                        rule : 'required'
                    }/*,{
                        message : 'fields.strongpassword',
                        rule : 'regex:^(?=.*[!@#$%^&*-])(?=.*[0-9])(?=.*[A-Z]).{8,20}$'
                    }*/]
                },
                {
                    id : 'Confirm password field',
                    text : 'fields.confirmpassword',
                    textrequired : 'fields.confirmpasswordRequiered',
                    type : "password",
                    rules : [{
                        rule : 'required'
                    },{
                        rule : 'same:Password'
                    }]
                }
            ]
        }

    },

    created() {
        
    },

    mounted(){
        this.$refs.fields.get()
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        valid : function(){
            return !_.isEmpty(this.values)/* && this.values.Password && (this.values.Password == this.values.cpassword)*/
        }
    }),

    methods : {
        save : function(){

            this.values = this.$refs.fields.get()

            if (!this.valid){
                
                this.core.sitemessage(this.$t("fields.formfillerrorTitle") + ": " + this.$t("fields.formfillerror"))

                return
            }

            var data = {
                login : this.values.Email,
                password : this.values.Password
            }

            this.$store.commit('globalpreloader', true)

            this.core.user.signup(data, this.type).then(r => {

                if(this.type == 4){
                    this.$router.push('/panel/partnerinfo').catch(e => {})
                }
                else{
                    this.$router.push('/').catch(e => {})
                }

                

            }).catch((e) => {

                console.log(e)

                this.$store.commit('icon', {
					icon: 'error',
					message: this.$t(e.error || "errors.general")
				})

            }).finally(() => {
                this.$store.commit('globalpreloader', false)
            })
        },

        input : function(v){
            this.values = v
        }
    },
}